import React, { useEffect } from 'react';
import CustomModal from '../../../../baseComponents/gui/customModal/CustomModal';
import { useModal } from '../../../../../hooks/useModal';
import classNames from 'classnames';
import AppLoader from '../../../appLoader/AppLoader';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import Header from './Header/Header';
import MyPrizes from './MyPrizes/MyPrizes';
import WinnersList from './WinnersList/WinnersList';
import useFullProps from '../../model/hooks/useFullProps';
import useScrollLogic from '../../model/hooks/useScrollLogic';
import Wrapper from './Wrapper/Wrapper';

export default function Modal() {
  const callbacks = useApplicationCallbacks();
  const fullProps = useFullProps();
  const scrollHandlers = useScrollLogic({ ...fullProps, isUseScrollLogic: false });
  const { id, closeModal } = useModal();

  useEffect(() => {
    callbacks.getDrawingResultWinners({ page: 1 });
  }, []);

  return (
    <CustomModal className={classNames('custom-modal_fullpage')} animation={['fade']} closeOnClickOutside>
      <div
        className={classNames('drawing-result-modal', `drawing-result-modal_${fullProps?.status}`, {
          'drawing-result-modal_list': fullProps?.prizes?.length,
        })}
      >
        <div className={'drawing-result-modal__content'}>
          <div className={'drawing-result-modal__bg'} onClick={() => closeModal(id)} />
          <Wrapper {...fullProps} {...scrollHandlers}>
            <Header {...fullProps} />
            <MyPrizes {...fullProps} />
            <WinnersList {...fullProps} />
          </Wrapper>
        </div>
      </div>
      {fullProps.isPending && <AppLoader />}
    </CustomModal>
  );
}
